import React from 'react';
import { Box, Circle, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { FiTrendingUp, FiStar, FiUsers } from 'react-icons/fi';
import { FaCrown } from 'react-icons/fa';
import DiamondIllustration from './DiamondIllustration';
import ModalShell from '../../../../components/ui/ModalShell';
import { DisplayHeading } from '../../../../components/ui';
import { ff } from '../../../../theme';

const PERKS = [
  {
    icon: FaCrown,
    title: 'Priority Opportunities',
    desc: 'Get early access to top brand campaigns and premium collabs.',
  },
  {
    icon: FiTrendingUp,
    title: 'Higher Earning Potential',
    desc: 'Diamond creators are invited to higher budget opportunities.',
  },
  {
    icon: FiStar,
    title: 'Increased Visibility',
    desc: 'Your profile is highlighted to brands looking for top creators.',
  },
  {
    icon: FiUsers,
    title: 'Exclusive Perks',
    desc: 'Be the first to access new features, events, and special programs.',
  },
] as const;

export interface DiamondTierModalProps {
  isOpen: boolean;
  onClose: () => void | Promise<void>;
}

const DiamondTierModal: React.FC<DiamondTierModalProps> = ({ isOpen, onClose }) => (
  <ModalShell
    isOpen={isOpen}
    onClose={() => void onClose()}
    primary={{ label: 'Got it', onClick: () => void onClose(), tone: 'lime' }}
  >
    <Box textAlign="center">
      <DiamondIllustration />
      <Box mt={2}>
        <DisplayHeading as="h2" size="27px">Diamond Creator</DisplayHeading>
      </Box>
      <Text fontSize="15px" color={ff.text2} mt={3} lineHeight="1.5">
        You&apos;re in the top 1% of creators on FoodFluence — and that&apos;s a big deal.
      </Text>
    </Box>

    <VStack spacing={4} align="stretch" bg={ff.grey} borderRadius="20px" mt={5} p={5}>
      {PERKS.map((perk) => (
        <HStack key={perk.title} spacing={4} align="flex-start">
          <Circle size="44px" bg={ff.lime} flexShrink={0}>
            <Icon as={perk.icon} boxSize={5} color={ff.ink} />
          </Circle>
          <VStack align="start" spacing={1} flex={1}>
            <Text fontWeight={600} fontSize="14px" color={ff.ink}>
              {perk.title}
            </Text>
            <Text fontSize="14px" color={ff.text2} lineHeight="1.5">
              {perk.desc}
            </Text>
          </VStack>
        </HStack>
      ))}
    </VStack>
  </ModalShell>
);

export default DiamondTierModal;
